import { jsx as _jsx } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import CountLogo from './CountLogo';
export default function CountCard() {
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('count');
    const { t } = useLocaleKeys('integrations.count');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "count-card",
        icon: /*#__PURE__*/ _jsx(CountLogo, {}),
        title: t.title(),
        subTitle: t.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_count'
            },
            onClick: showCopyAPIKeyModal,
            testId: "count-card-connect",
            children: t.connect()
        })
    });
}
